module.exports = __webpack_public_path__ + "static/media/no-value (1).c2289f97.svg";